import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin({
  name: 'auth-restore',
  dependsOn: ['shared-app-store', 'app-request-context'],
  async setup(nuxtApp) {
    try {
      const { restoreLoginState } = useLogin(nuxtApp.$pinia)
      await restoreLoginState()
    } catch {
      // auth cookies may not exist — no user to restore
    }
  },
})
